module.exports = "./img/desktop_logo.127ddc5.png";